import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const WelcomeContainer = styled.div`
  min-height: 100vh;
  background-color: white;
  font-family: 'Noto Sans Thai', sans-serif !important;
  * {
    font-family: 'Noto Sans Thai', sans-serif !important;
    font-weight: normal;
    color: #666666;
  }
`;

const Header = styled.div`
  background: white;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Logo = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
`;

const HeaderTitle = styled.h1`
  font-size: 18px;
  font-weight: bold;
  color: #666;
  margin: 0;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const NotificationContainer = styled.div`
  position: relative;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

const BellIcon = styled.div`
  width: 24px;
  height: 24px;
  background-image: url("data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z' fill='%23666666'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;

const NotificationBadge = styled.div`
  position: absolute;
  top: -6px;
  right: -6px;
  background-color: #ff4444;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Noto Sans Thai', sans-serif !important;
  min-width: 18px;
  padding: 0 2px;
`;

const Content = styled.div`
  padding: 0;
  max-width: 100%;
  margin: 0;
`;

const WelcomeTitle = styled.h1`
  font-size: 20px;
  font-weight: normal;
  color: white;
  background-color: #00BBD3;
  text-align: left;
  margin: 0 0 40px 0;
  padding: 16px 24px;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const ProfileSection = styled.div`
  display: flex;
  gap: 40px;
  padding: 20px 40px;
  align-items: start;
`;

const ProfileImageContainer = styled.div`
  flex-shrink: 0;
`;

const ProfileImage = styled.img`
  width: 91px;
  height: 91px;
  border-radius: 50%;
  object-fit: cover;
`;


const ProfileDetailsContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 100%;
`;

const ProfileDetailRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 20px;
`;

const ProfileDetailLabel = styled.span`
  font-size: 16px;
  color: #666666;
  font-weight: normal;
  font-family: 'Noto Sans Thai', sans-serif !important;
  margin-right: 8px;
  min-width: 60px;
`;

const ProfileDetailValue = styled.span`
  font-size: 16px;
  color: #666666;
  font-weight: normal;
  font-family: 'Noto Sans Thai', sans-serif !important;
  flex: 1;
  text-align: left;
  word-wrap: break-word;
`;

const DecorativeImageContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 40px 0;
`;

const DecorativeImage = styled.img`
  width: 200px;
  height: 150px;
  object-fit: contain;
`;

const ActionButton = styled.button`
  background-color: #00BBD3;
  color: white;
  border: none;
  border-radius: 30px;
  padding: 18px 32px;
  font-size: 18px;
  font-weight: normal;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  font-family: 'Noto Sans Thai', sans-serif !important;
  box-shadow: 0 9px 14px 0 rgba(0, 187, 211, 0.08);
  margin: 20px 40px;
  max-width: calc(100% - 80px);

  &:hover {
    background-color: #009bb3;
  }

  &:active {
    background-color: #008aa0;
  }
`;

const WelcomePage = () => {
  const navigate = useNavigate();

  // Mock user data - ใช้ข้อมูลจริงจาก previous steps หรือข้อมูล mock
  const mockUserData = {
    fullName: 'คุณ พงษ์ชัย เพชรสังหาร',
    gender: 'ชาย',
    age: 45,
    birthDate: '18 สิงหาคม 2524'
  };

  const [notificationCount, setNotificationCount] = React.useState(3);

  const handleDailyHealthRecord = () => {
    // นำไปยังหน้าบันทึกข้อมูลสุขภาพประจำวัน
    console.log('ไปยังหน้าบันทึกข้อมูลสุขภาพ');
    navigate('/daily-health-record');
  };

  const handleNotificationClick = () => {
    navigate('/notifications');
  };

  return (
    <WelcomeContainer>
      <Header>
        <HeaderLeft>
          <Logo src="./logo.png" alt="MFU Logo" />
          <HeaderTitle>MFU Wellness Center</HeaderTitle>
        </HeaderLeft>
        <NotificationContainer onClick={handleNotificationClick}>
          <BellIcon />
          {notificationCount > 0 && (
            <NotificationBadge>{notificationCount}</NotificationBadge>
          )}
        </NotificationContainer>
      </Header>

      <Content>
        <WelcomeTitle>ยินดีต้อนรับสู่ MFU Wellness Center</WelcomeTitle>
        
        <ProfileSection>
          <ProfileImageContainer>
            <ProfileImage src="./person.png" alt="Profile" />
          </ProfileImageContainer>
          
          <ProfileDetailsContainer>
            <ProfileDetailValue>
              {mockUserData.fullName} เพศ{mockUserData.gender} อายุ {mockUserData.age} วันเกิด {mockUserData.birthDate}
            </ProfileDetailValue>
          </ProfileDetailsContainer>
        </ProfileSection>

        <DecorativeImageContainer>
          <DecorativeImage src="./Frame.png" alt="Decorative Frame" />
        </DecorativeImageContainer>

        <ActionButton onClick={handleDailyHealthRecord}>
          คลิกเพื่อบันทึกข้อมูลสุขภาพประจำวัน
        </ActionButton>
      </Content>
    </WelcomeContainer>
  );
};

export default WelcomePage;